import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { Progress } from "..";

const useStyles = makeStyles(theme => ({
  titleContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  submissionText: {
    ...theme.typography.subtitle2,
    color: theme.palette.text.disabled,
    marginRight: theme.spacing(2),
  },
  error: {
    color: "red",
    ...theme.typography.body1,
  },
}));

/**
 * SubmissionText component displays the submission period date range.
 * Shows the period start and end dates in DD.MM.YYYY format,
 * along with loading state and error messages.
 *
 * @param {Object} period - Period object containing periodStartDate and periodEndDate
 * @param {boolean} isFetching - Whether data is currently being fetched
 * @param {*} error - Error object or message to display
 */
function SubmissionText({ period, isFetching, error }) {
  const classes = useStyles();
  const { t } = useTranslation();

  const { periodStartDate, periodEndDate } = period;
  const text = `${t("submissionPeriod")} ${moment(periodStartDate).format(
    "DD."
  )}-${moment(periodEndDate).format("DD.MM.YYYY")}`;

  return (
    <div className={classes.titleContainer}>
      <Typography className={classes.submissionText}>{text}</Typography>
      <Progress show={isFetching} size={25} />
      {error != null && (
        <Typography className={classes.error}>{t("networkError")}</Typography>
      )}
    </div>
  );
}

SubmissionText.propTypes = {
  period: PropTypes.shape({
    periodStartDate: PropTypes.string,
    periodEndDate: PropTypes.string,
  }).isRequired,
  isFetching: PropTypes.bool,
  error: PropTypes.node,
};

SubmissionText.defaultProps = {
  isFetching: false,
  error: null,
};

export default SubmissionText;
